import { Component, OnInit, OnDestroy, Injectable,Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import {Message} from '@stomp/stompjs';
import { Constants } from '../../../app.constant';
import { filter, startWith, takeUntil } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import {StompConfig, StompService, StompState} from '@stomp/ng2-stompjs';
import {stompConfig} from '../../../models/rx-stomp-config';
import { NotificationService } from "../../../services/notification.service";
import { ToasterService } from 'angular2-toaster';
import { WebNotification, NonSlientMessageTypes } from '../../../pages/shared/components/notification/models/notification'
@Injectable()
export class PushNotificationService {
  private notiList: Array<WebNotification> = [];
  public notificationList: BehaviorSubject<WebNotification[]> = new BehaviorSubject(this.notiList);
  // Stream of messages
  private subscription: Subscription;
  public messages: Observable<Message>;
  private messageSource = new Subject();
  // private messageSource : ReplaySubject<any> = new ReplaySubject(1);
  // Subscription status
  public subscribed: boolean;

  // Array of historic message (bodies)
  public mq: Array<string> = [];
  public sourceArray: Array<string> = [];
  private isMessageOnce: boolean = false;

  // A count of messages received
  public count = 0;

  private _counter = 1;
  private _stompService;
  /** Constructor */
  constructor(
    private injector: Injector,
    private notificationService: NotificationService, 
    private toasterService: ToasterService) {
    //console.log("push notification service constructor ==> ");
    if(!Constants.Var.sslOn){
      let _stompConfig=stompConfig;
      _stompConfig.url = Constants.setStompConfig('url'),
      _stompConfig.headers.login = Constants.setStompConfig('loginName'),
      _stompConfig.headers.passcode = Constants.setStompConfig('passcode')
      console.log("_stompConfig ==> ", _stompConfig)
      this._stompService = new StompService(_stompConfig); //this.injector.get(StompService);
    }


    }

  // ngOnInit() {
  //   // this.subscribed = false;

  //   // // Store local reference to Observable
  //   // // for use with template ( | async )
  //   // this.subscribe();
  //   console.log("push notification service ngoninit ==> ");
  // }

  public subscribe() {
    if (this.subscribed) {
      console.log("susbsribed already ==> ")
      return;
    }

    // Stream of messages
    this.messages = this._stompService.subscribe('/exchange/push_web_'+Constants.CurrentUserInfomations("userId"));
    //this.messages = this._stompService.subscribe('/exchange/12');

    // Subscribe a function to be run on_next message
    // this.subscription = this.messages.subscribe(message =>{
    //   this.messageSource.next(message.body);
    // });

    this.subscription = this.messages.subscribe(this.on_next);

    this.subscribed = true;
  }

  public unsubscribe() {
    if (!this.subscribed) {
      return;
    }

    // This will internally unsubscribe from Stomp Broker
    // There are two subscriptions - one created explicitly, the other created in the template by use of 'async'
    this.subscription.unsubscribe();
    this.subscription = null;
    this.messages = null;
    this.subscribed = false;
  }

  ngOnDestroy() {
    this.unsubscribe();
  }

  public onSendMessage() {
    this.subscribed = false;

    // Store local reference to Observable
    // for use with template ( | async )
    this.subscribe();
    const _getRandomInt = (min, max) => {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    this._stompService.publish('/exchange/push_web_'+Constants.CurrentUserInfomations("userId"),
    //this._stompService.publish('/exchange/12',
      `{ type: "Test Message", data: [ ${this._counter}, ${_getRandomInt(1, 100)}, ${_getRandomInt(1, 100)}] }`);

    this._counter++;
  }

  /** Consume a message from the _stompService */
  public on_next = (message: Message) => {

    // Store message in "historic messages  " queue
    this.mq.push(message.body);
    //this.sourceArray.push(message.body);
    // if (this.isMessageOnce != true) {
    //   this.isMessageOnce = true;
    this.messageSource.next(message.body);
    if (message.body) {
      let response = this.convertToJSON(message.body);
      console.log("step 1")
      this.isKeyExist(NonSlientMessageTypes, response.messageType).subscribe(res => {
        console.log("step 2")
        if (res == true) {
          this.notificationService.prependValue(new WebNotification(response));
          // this.toasterService.pop('info', 'New Message', response.messageTitle);
          let options = { //set options
            body: message.body,
            renotify: false
            // icon: "assets/images/ironman.png" //adding an icon
          }
          // this.pushNotificationsService.create("New Message", options).subscribe( //creates a notification
          //   res => { console.log(res); },
          //   err => console.log(err)
          // );
        }
      })
    }
    // }
    // Count it
    this.count++;

    // Log it to the console
    // console.log("message on_next ==>",message);
    // console.log("on_next messagSource => ", this.messageSource)
  }

  isKeyExist(keys: Array<string>, messageType: any): Observable<boolean> {
    let messageTypeList = Constants.NotificationConfigKeysInformations();
    return Observable.create(observer => {
      let isExist: boolean = false;
      let messageTypeKey;
      if (keys && keys.length > 0 && messageType != null) {
        messageTypeKey = Object.keys(messageTypeList).find(key => messageTypeList[key] == messageType)
        isExist = keys.indexOf(messageTypeKey) > -1
      }
      observer.next(isExist)
      observer.complete()
    })
  }

  convertToJSON(str) {
    try {
      var obj = JSON.parse(str);
      if (obj && typeof obj === 'object' && obj !== null) {
        return obj;
      }
      else {
        return null;
      }
    } catch (err) { }
  }

  /* fcm copy start */

  // used to show message when app is open
  /*receiveMessages() {
    if (this.isMessageOnce != true) {
      this.isMessageOnce = true;
      this.messaging.onMessage((payload: any) => {
        this.messageSource.next(payload);
        if (payload && payload.data.result != null) {
          let response=this.convertToJSON(payload.data.result);
          this.isKeyExist(NonSlientMessageTypes, response.messageType).subscribe(res => {
            if (res == true) {
              this.notificationService.prependValue(new WebNotification(response));
              this.toasterService.pop('info', 'New Message', response.messageTitle);
            }
          })
        }
      });
    }
  }*/

  onMessageStomp() {
    console.log("on vicky ==> ", this.mq);
    this.messageSource.next(this.mq)
  }

  receiveMessageByKey(keys: Array<string>): Observable<any> {
    this.subscribe();
    //console.log("Device Listing Step 2")
    return Observable.create(observer => {
      //console.log("Device Listing Step 4");
      this.messageSource
        .subscribe((payload: any) => {
          //console.log("step 5 ==> ", payload)
          // if (payload && payload.data.result != null) {
          //   console.log("step 6 ==> ")
          //   let response=this.convertToJSON(payload.data.result);
          //   this.isKeyExist(keys, response.messageType).subscribe(res => {
          //     console.log("step 7 ==> ")
          //     if (res == true) observer.next(response);
          //   })
          // }
          if (payload) {
            let response = this.convertToJSON(payload);
            console.log("abhik response", response)
            this.isKeyExist(keys, response.messageType).subscribe(res => {
              if (res == true) observer.next(response);
            })
          }
        })
      return () => {
        console.log("Device Listing Step 3")
        // this.messageSource.unsubscribe()
        // this.messageSource.complete()
      };
    })

  }


  /* fcm copy end */


}


// WEBPACK FOOTER //
// ./src/app/pages/shared/services/push-notification.service.ts